export default "__VITE_ASSET__BPbQZg7m__"